/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_FailedInputs */

const en_signin_failed = /** @type {(inputs: Signin_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in did not go through. Try again in a moment.`)
};

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const ar_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const he_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const ur_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const es_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const fr_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const de_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const pt_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const hi_signin_failed = en_signin_failed;

/** @type {(inputs: Signin_FailedInputs) => LocalizedString} */
const bn_signin_failed = en_signin_failed;

/**
* | output |
* | --- |
* | "Sign-in did not go through. Try again in a moment." |
*
* @param {Signin_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_failed = /** @type {((inputs?: Signin_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_failed(inputs)
	if (locale === "he") return he_signin_failed(inputs)
	if (locale === "ur") return ur_signin_failed(inputs)
	if (locale === "es") return es_signin_failed(inputs)
	if (locale === "fr") return fr_signin_failed(inputs)
	if (locale === "de") return de_signin_failed(inputs)
	if (locale === "pt") return pt_signin_failed(inputs)
	if (locale === "hi") return hi_signin_failed(inputs)
	if (locale === "bn") return bn_signin_failed(inputs)
	return /** @type {LocalizedString} */ ("Sign-in did not go through. Try again in a moment.")
});